import { toNote } from '@/lib/link'
import { tagNameEquals } from '@/lib/tag'
import { cn } from '@/lib/utils'
import { Event } from '@nostr/tools/wasm'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export default function GeocacheCurationListPreview({
  event,
  className
}: {
  event: Event
  className?: string
}) {
  const { t } = useTranslation()
  const title = useMemo(
    () => event.tags.find(tagNameEquals('title'))?.[1] || event.tags.find(tagNameEquals('d'))?.[1],
    [event]
  )
  const count = useMemo(
    () => event.tags.filter((t) => t[0] === 'a' && t[1].startsWith('37516:')).length,
    [event]
  )

  return (
    <div className={cn('pointer-events-none', className)}>
      [{t('Geocache list')}]{' '}
      <a href={toNote(event)} onClick={(e) => e.preventDefault()} className="italic pr-0.5">
        {title}
      </a>
      {count > 0 && <span className="ml-1">({count})</span>}
    </div>
  )
}
